export default {
  teachers: {
    ru: ['лучший преподаватель', 'лучших преподавателя', 'лучших преподавателей'],
    en: ['best teacher', 'best teachers', 'best teachers'],
    he: ['המורה הכי טוב', 'המורה הכי טוב', 'המורים הטובים ביותר'],
  },
}
